// Copyright (c) 2016 Deere & Company

import {
    isNotEmpty,
    isNotNull,
    isNumberInputValid,
    isRepairDateAfterFailureDate,
    validateClaimUseAmountUnits,
    validateClaimUseAmounts,
    validateUseAmountsIfPinExists
} from '../../shared/services/claim-shared-helper';
import BatteryClaim from '@deere/cps-it.warranty-model-factory/lib/claim-battery';
import {removeEmptyRows} from '../../shared/services/empty-claim-rows';

const hasAtLeastOneClaimItem = claim =>
    claim.parts.length || claim.labor.length || claim.otherCredits.length;

const isNotRequiredForReplacement = (claim, value) =>
    claim.installedBy.key === 'R' || isNotEmpty(value);

const hasComplaintCauseCorrection = complaintCauseCorrection => [
    isNotEmpty(complaintCauseCorrection.causeOfComplaining),
    isNotEmpty(complaintCauseCorrection.howWasComplaintCorrected),
    isNotEmpty(complaintCauseCorrection.operatorsComplaint)
].every(rule => rule);

const isComplaintCauseCorrectionValid = (installedBy, complaintCauseCorrection) =>
    installedBy === 'R' ?
        isNotEmpty(complaintCauseCorrection.causeOfComplaining) :
        hasComplaintCauseCorrection(complaintCauseCorrection);

export const canShowAllSections = (claimNumber, isValidClaim) =>
    isValidClaim || isNotEmpty(claimNumber);

export const isReplacement = (installedBy, claim) =>
    installedBy === 'R' ?
        isNumberInputValid(claim.retailInstallDate) :
        true;

export const isValidClaim = (claim, allowedUnitsLength) => [
    isNotEmpty(claim.failureInfo.failurePartNumber),
    isNotRequiredForReplacement(claim, claim.pin),
    validateUseAmountsIfPinExists(claim, allowedUnitsLength),
    isNotEmpty(claim.responsibleAccount.account),
    isNotEmpty(claim.installedBy.key),
    claim.installedBy.key === 'R' ?
        true :
        isNotEmpty(claim.referenceInfo.ownershipStatus.key),
    isNotEmpty(claim.referenceInfo.referenceNumber1),
    isReplacement(claim.installedBy.key, claim),
    isNotNull(claim.failureInfo.failureDate),
    isNotNull(claim.failureInfo.repairDate),
    isRepairDateAfterFailureDate(claim.failureInfo.repairDate, claim.failureInfo.failureDate)
].every(rule => rule);

export const saveValidate = claim => [
    isValidClaim(claim),
    isNotEmpty(claim.application.key),
    isNotEmpty(claim.additionalFailureInfo.failureMode.key),
    isComplaintCauseCorrectionValid(claim.installedBy.key, claim.complaintCauseCommentsBasis),
    hasAtLeastOneClaimItem(removeEmptyRows(claim, BatteryClaim))
].every(rule => rule);

export const mapFormValidation = (property, value, claim) => {

    const boundIsNotRequiredForReplacement = isNotRequiredForReplacement.bind(null, claim);

    const map = {
        application: isNotEmpty,
        complaintCause: isNotEmpty,
        complaintCorrection: boundIsNotRequiredForReplacement,
        failureArea: isNotEmpty,
        failureDate: isNotNull,
        failureMode: isNotEmpty,
        failurePart: isNotEmpty,
        installedBy: isNotEmpty,
        operatorsComplaint: boundIsNotRequiredForReplacement,
        ownershipStatus: boundIsNotRequiredForReplacement,
        pin: boundIsNotRequiredForReplacement,
        previousInvoiceNumber: isNotEmpty,
        repairDate: isNotNull,
        responsibleAccount: isNotEmpty,
        retailInstallDate: isNotNull,
        useAmount: validateClaimUseAmounts,
        useAmountUnit: validateClaimUseAmountUnits,
        workOrderOne: isNotEmpty
    };

    return map[property](value, claim);

};

export const checkClaimValidity = (currentPageValidity, validationFailed, selectedAction) =>
    selectedAction === 'VALIDATE' ?
        !validationFailed && !currentPageValidity :
        false;



// WEBPACK FOOTER //
// ./src/claim/battery/services/claim-validation-helper.js